import { SxStyles } from '../../../types';
import theme from '../../../theme';
import { getResponsiveSize } from '../../../utils';
import { PSYLARIS_DARK, PSYLARIS_LIGHT_GREY } from '../../../utils/Colors';

export const CompositeBackgroundButtonSXStyles: SxStyles = {
  compositeBackgroundButtonFab: {
    m: getResponsiveSize(8),
    backgroundColor: PSYLARIS_LIGHT_GREY,
    color: PSYLARIS_DARK,
  },
  compositeBackgroundButtonMenuPaper: {
    width: 'min(90vw, 340px)',
    minWidth: 'min(90vw, 280px)',
    maxWidth: 'calc(100vw - 32px)',
    borderRadius: getResponsiveSize(16),
    overflow: 'hidden',
    border: `1px solid ${theme.palette.neutral?.grey10}`,
    boxShadow: theme.palette.propVars?.btnBoxShadow,
    '& .MuiMenu-list': {
      p: 0,
      backgroundColor: theme.palette.myPrimary?.white,
    },
    [theme.breakpoints.media?.tablet!]: {
      width: 'min(92vw, 340px)',
      minWidth: 'min(92vw, 280px)',
      maxWidth: 'calc(100vw - 16px)',
    },
  },
  compositeBackgroundButtonHeader: {
    px: getResponsiveSize(16),
    pt: getResponsiveSize(12),
    pb: getResponsiveSize(6),
    [theme.breakpoints.media?.tablet!]: {
      px: getResponsiveSize(12),
      pt: getResponsiveSize(10),
      pb: getResponsiveSize(6),
    },
  },
  compositeBackgroundButtonTitle: {
    fontFamily: theme.typography.mainFontFamily,
    fontSize: theme.typography.fs14,
    color: theme.palette.neutral?.grey70,
  },
  compositeBackgroundButtonHelper: {
    px: getResponsiveSize(16),
    pb: getResponsiveSize(10),
    [theme.breakpoints.media?.tablet!]: {
      px: getResponsiveSize(12),
      pb: getResponsiveSize(8),
    },
  },
  compositeBackgroundButtonHelperText: {
    fontFamily: theme.typography.mainFontFamily,
    fontSize: theme.typography.fs12,
    color: theme.palette.mainControls?.backText,
  },
  compositeBackgroundButtonErrorText: {
    fontFamily: theme.typography.mainFontFamily,
    fontSize: theme.typography.fs12,
    color: theme.palette.neutral?.error,
  },
  compositeBackgroundButtonDivider: {
    borderColor: theme.palette.neutral?.grey10,
  },
  compositeBackgroundButtonMenuItem: {
    px: getResponsiveSize(16),
    py: getResponsiveSize(10),
    minHeight: getResponsiveSize(48),
    transition: theme.palette.propVars?.linearTransition,
    '& .MuiListItemIcon-root': {
      minWidth: getResponsiveSize(32),
      color: theme.palette.mainControls?.subTitleColor,
    },
    '& .MuiListItemText-primary': {
      fontFamily: theme.typography.mainFontFamily,
      fontSize: theme.typography.fs13,
      color: theme.palette.neutral?.grey70,
    },
    '& .MuiListItemText-secondary': {
      fontFamily: theme.typography.mainFontFamily,
      fontSize: theme.typography.fs12,
      color: theme.palette.mainControls?.backText,
    },
    '&:hover, &:focus': {
      backgroundColor: theme.palette.neutral?.grey4,
    },
    '&.Mui-selected': {
      backgroundColor: theme.palette.myPrimary?.lightBlue20,
    },
    '&.Mui-selected:hover, &.Mui-selected:focus': {
      backgroundColor: theme.palette.myPrimary?.lightBlue30,
    },
    '&.Mui-selected .MuiListItemIcon-root, &.Mui-selected .MuiListItemText-primary': {
      color: theme.palette.mainControls?.mainBlue,
    },
    '&.Mui-selected .MuiListItemText-secondary': {
      color: theme.palette.mainControls?.mainBlue,
    },
    [theme.breakpoints.media?.tablet!]: {
      px: getResponsiveSize(12),
      py: getResponsiveSize(9),
      minHeight: getResponsiveSize(44),
    },
  },
};
